module.exports = __webpack_public_path__ + "img/internamientos.4f0b60d5.png";